import { makeStyles } from '@material-ui/core/styles'

// Any time that we would like to add CSS to our Components we will create a styles object. The syntax is different then normal CSS. Please notice that camel case is used to set the list-style-type. For your reference please visit https://v4.mui.com
export const lotLabelStyles = makeStyles(() => ({
  lotLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}))

export default lotLabelStyles
